import { get } from "lodash-es";
import { InternalOption, SelectChangeOption } from "./types";

/* eslint-disable no-underscore-dangle */

// Convert value = string | string[] | null into a prop supported by ReactSelect.
export const resolveValue = (
  value: any,
  formValue: any,
  options: any[],
  optionValue: string
) => {
  let valueOptions: InternalOption | InternalOption[] = [];

  if (formValue !== undefined) {
    if (Array.isArray(formValue)) {
      valueOptions = formValue.map(val =>
        options.find(opt => get(opt, optionValue) === val)
      );
    } else {
      valueOptions = options.find(opt => get(opt, optionValue) === formValue);
    }
  }

  if (value !== undefined) {
    if (Array.isArray(value)) {
      valueOptions = value.map(val =>
        options.find(opt => get(opt, optionValue) === val)
      );
    } else {
      valueOptions = options.find(opt => get(opt, optionValue) === value);
    }
  }

  return valueOptions;
};

// Get newly created options.
export const getCreatedOptions = (
  options: SelectChangeOption | SelectChangeOption[] | null
) => {
  if (options === null) {
    return [];
  }

  if (Array.isArray(options)) {
    return options.filter(opt => opt.__isNew__).filter(Boolean);
  }

  return options.__isNew__ ? [options] : [];
};

// Convert onChange value into AutoComplete value.
export const optionsToValue = (
  options: SelectChangeOption | SelectChangeOption[] | null,
  optionValue: string
) => {
  if (options === null) {
    return [null, null];
  }

  if (Array.isArray(options)) {
    return [options.map(opt => get(opt, optionValue)), options];
  }

  return [get(options, optionValue), options];
};
